<template>
<div class="newItem" @click="tapMe(item)">
    <div  :class="item.tempview=='1'?' n-item flex-sb current':'n-item flex-sb '">
         <div class="roll" :style="{width:width,height: height,background:item.promType}">
               <img :src="getImgUrlP(item.pic)" :style="{width:width,height: height}" class="biger" v-if="item.litpic!=''"  />   
               <img  :src="require(`@/assets/images/1/xwlb_date_${item.updateTime.substr(8,2)}.png`)"   style="width:82px;height: 50px; margin-top:17px " class="biger"  v-else /> 
         </div>
         <div class="atext" :style="{width:width}">     
           <div class="f18 c3"><strong>{{item.ArtTitle}}</strong></div>
           <div class="f16 c9 ln28" :style="{height:lnheight}">{{item.Content}}</div>
         </div>
    </div>
</div>
</template>
<script>
export default {
  props:['type','width','height','lnheight','item','index','lmid'],
    data(){
            return{
             
            }
    },
    methods: {
          getImgUrlP (src) {
            //  var src = "http://pc.shihua.com/prod-api/"+ src
            return src
          },
          tapMe(item){   
           
            var data = {
              aid:item.ArtID,
              index:this.index
            }
            this.$emit('tapDetail',data)    
            // this.$router.push({path: '/News/detail?id='+item.ArtID })     
          }
    }
}
</script>
<style scoped>
.newItem {
  background: #fcfeff;
  cursor:pointer
}
.newItem .n-item{
  padding:20px 10px;
  position: relative;
  border-bottom:1px solid #eee
}
.newItem:last-child {
  margin:0
}
.newItem .atext{
  flex:1;
  height: 84px;
  overflow: hidden;
}
.newItem .atext .f18{
  margin-bottom: 4px ;
  height:28px;
  line-height: 28px; 
  text-overflow: ellipsis; 
  white-space: nowrap; 
  padding:0 20px;
  overflow: hidden;
}
.newItem .atext .date{
  margin: 30px 20px;
}
.newItem .atext .ln28{
   overflow:hidden;
   padding-left:20px;
}
.n-item:hover,.current{
  background: #fcfeff;
  border-left:10px solid #2A579E;
 box-shadow: 0px 1px 10px 0px rgba(41,87,157,0.20); 
}
.current .c3{
 
  color:#0F5175;
 
}
.n-item:hover .f18{
    color:#2A579E
}
.n-item .biger{
  transition: all 0.6s;
}
.n-item:hover  .biger{
   transform: scale(1.2);
}
.n-item .roll{
  overflow: hidden;
  display:block;
   text-align:center; 
}
</style>



// WEBPACK FOOTER //
// src/components/NewItemR.vue